var _metadata, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTourism(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    enableBackground: "new 0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M231.7,24.9c-2.7-3.4-16.8-3.7-27.7,7.4l-48.3,48c0,0-2.7,3.6-9,3.4l-96.6-5.8c0,0-3.1-0.2-5.3,2.1L30.7,92.7l64.7,24c0,0,4.8,1.6,7.1,5.8c1.8,3.1,2,8.7-1.1,11.9l-28.2,29.6c0,0-3.8,5.3-11.3,4.7h-33l-3.9,2.6l31.9,20.1c0,0,3.4,2,4.7,3.2c1.8,2,3.2,4.6,3.2,4.7l0,0c0,0,0,0,0,0l20,31.9l2.6-3.9v-33c-0.6-7.5,4.7-11.3,4.7-11.3l29.5-28.2c3.2-3,8.8-2.8,11.9-1.1c4.2,2.4,5.8,7.1,5.8,7.1l24,64.6l12.7-14.3c2.3-2.2,2.1-5.3,2.1-5.3l-5.8-96.6c-0.2-5,2.1-7.7,3.1-8.6L223,53.1c0,0,5-4.5,7.7-10.5C233.5,36.1,234.1,27.8,231.7,24.9z M236.2,57.3l-51.2,52l5.5,90.2c0,0,2.7,13.5-5.8,20.9l-14.5,16.1c0,0-11.8,9.8-18.7-3.4l-24-65.7l-27.2,26.1l-0.5,31.9c0,0,0.7,5-2.6,10.3l-5.5,6.9c0,0-9.9,7.7-16.3-1.3L52.3,204l-37.9-23.2c-9-6.5-1.3-16.4-1.3-16.4l6.9-5.5c5.3-3.3,10.3-2.6,10.3-2.6l31.9-0.5l26.1-27.2l-65.7-24c-13.2-7-3.4-18.7-3.4-18.7l16.1-14.5c7.3-8.5,20.9-5.8,20.9-5.8l90.4,5.7L193,24.6c0,0,15.1-17.4,37.7-13.7c0,0,15.5,1,15.3,22.2C246,33.1,245.4,46.6,236.2,57.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTourism);
export default __webpack_public_path__ + "static/media/Tourism.1b65193bc1950c12dd97bdc9166cb425.svg";
export { ForwardRef as ReactComponent };